import Cookies from 'js-cookie';

const COOKIE_NAME = 'tp_auth';
const COOKIE_DOMAIN = '.talentprofile.net';

export function isDashboardAuthenticated(): boolean {
	return Cookies.get(COOKIE_NAME) === '1';
}

export function clearDashboardAuth(): void {
	Cookies.remove(COOKIE_NAME, { domain: COOKIE_DOMAIN, path: '/' });
}